import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddress } from '../shared/interfaces/address';
import { IProfile } from '../shared/interfaces/profile';
import { ProfileService } from '../shared/services/profile.service';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {

  address: IAddress;
  whatsappApi: string;
  instagramUrl: string = environment.instagramUrl;
  facebookUrl: string = environment.facebookUrl;
  curriculoUrl: string = environment.curriculoUrl;
  email: string = environment.email;
  
  constructor(private profileService: ProfileService) { }

  ngOnInit(): void {
    let profile: IProfile = this.profileService.getProfile();
    this.address = profile.address;
    this.whatsappApi = environment.whatsappApiUrl + this.address.whatsAppNumber;
  }

}
